'use strict';

var text = require('./text');

module.exports = raw;

/* Stringify `raw`. */
function raw(ctx, node) {
  return ctx.dangerous ? node.value : text(ctx, node);
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-html/lib/raw.js
// module id = 992
// module chunks = 0